// @ts-nocheck
import React from 'react';
import news1 from '../../images/1.png';
import news2 from '../../images/2.jpg';
import general from '../../images/general02.png';
import news from '../../images/blog1_0.JPG';
import ugkc from '../../images/blog2_2.png';
import gaslo from '../../images/blog4_1.png';
import news3 from '../../images/3.jpg';
import Heading from 'Heading';
import CustomizedDialogs from 'components/dialog';

const NewsSDB = () => {
  const popups = [
    <>
      <h2 className="py-3 text-xl text-justify hyphens-auto font-bold text-[#A81414]">Що таке ораторія?</h2>
      <div>
        <div className="pt-3 pb-3">
          “Ораторія” (від лат. oratorium – місце молитви) – місце, де діти й молодь мають можливість весело і по-християнськи провести свій вільний час, навчитися чогось нового, зустрітися з друзями, перебуваючи у єдності з Богом.
        </div>
        <div className="pt-3 pb-3">
          Ораторія, або “місце молитви”, – це основне виховно-душпастирське середовище Салезіян.
          Саме так це назвав Святий отець Іван Боско, засновник Салезіян, адже у 1841 році у схожому місці почав збирати бідних та знедолених юнаків для того, щоб наблизити їх до Бога, навчити їх якогось ремесла, дати знання, прихисток та батьківську любов.
          Ораторія є також виховною спільнотою, яка проявляє себе в людському та християнському середовищі, що характеризується значною присутністю салезіян та вихователів серед молоді через пропозиції щодо формації для різних вікових груп.
        </div>
        <div className="pt-3 pb-3 text-[#A81414] font-bold">
          Ораторія у нашій традиції є:
        </div>
        <ul className="pl-6 list-disc text-[#A81414] font-bold">
          <li className="pt-1 pb-1">домом, який гостинно приймає усіх;</li>
          <li className="pt-1 pb-1">церквою, яка євангелізує;</li>
          <li className="pt-1 pb-1">школою, яка готує до життя;</li>
          <li className="pt-1 pb-1">подвір’ям для зустрічі з друзями.</li>
          <li className="pt-1 pb-1">Перша ораторія в Україні почала діяти при церкві Покрови Пресвятої Богородиці у Львові одразу після відкриття храму.</li>
        </ul>

      </div>
      <h2 className="py-3 text-xl font-bold text-[#A81414]">Аніматори</h2>
      <div>
        <ul className="flex flex-col gap-5 text-justify hyphens-auto ">
          <li>
            Спільнота салезіянських аніматорів – це хлопці та дівчата, які відчули у своєму житті покликання служити дітям, даруючи свій час, таланти. а передусім свою віру та цінності добрих християн та чесних громадян. Спільнота аніматорів також потребує бути формованою. Через це кожного місяця відбуваються одноденні курси аніматорів, а також є пропозиції більш поглибленої формації, яка відбувається протягом трьох днів, і щотижневих зустрічей, які називаються РЕЗУМ (зустрічі християнської молоді), які слідують програмі напрацьованій душпастирською комісією Провінції.
          </li>
        </ul>
      </div>
      <h2 className="py-3 text-xl font-bold text-[#A81414]">Молодь для молоді "МСР"</h2>
      <div className="text-justify hyphens-auto">
        Після закінчення Курсів Салезіянського Аніматора молодь ораторії прагне продовжувати бути в середовищі, яке для неї є рідним домом та колискою формації.
        Спільнота «молодь для молоді» є гарною можливістю бути тим продовженням, де старша молодь проходить постійну формацію, зростаючи і утверджуючись як добрі християни і чесні громадяни у перспективі виховання отця Боско.
        Це молодь, яка допомагає вести пасторальні напрямки в ораторії, стаючи провідниками, та надихає харизмою цілу структуру. Її завданням є передати цінності ораторії молодим поколінням.
        А також долучається до напрацювання виховно-душпастирських пропозицій.
      </div>
      <div className="text-justify hyphens-auto">
        Основним напрямом розвитку цієї молоді є участь у Молодіжному Салезіянському Русі (МСР), тобто відчувати себе великою салезіянською родиною, незалежно від того, в якій структурі ти виховувався.
      </div>
      <h2 className="py-3 text-xl font-bold text-[#A81414]">Ораторії в Україні</h2>
      <div className="text-[#A81414] font-bold pt-2">
        ОРАТОРІЯ СВЯТОГО ДОМІНІКА САВІО - ЛЬВІВ
      </div>
      <div className="text-[#A81414]">
        Відповідальний:
      </div>
      <div className="text-[#A81414]">
        Отець Тарас Милян, СДБ
      </div>
      <div className="text-[#A81414]">
        Вул. Личаківська, 175
      </div>
      <div className="text-[#A81414]">
        Львів
      </div>
      <div className="text-[#A81414] font-bold pt-2">
        ОРАТОРІЯ СВЯТОГО ІВАНА БОСКО – ВИННИКИ
      </div>
      <div className="text-[#A81414]">
        Відповідальний:
      </div>
      <div className="text-[#A81414]">
        Отець Григорій Швед, СДБ
      </div>
      <div className="text-[#A81414]">
        Вул. Галицька, 13 Б
      </div>
      <div className="text-[#A81414]">
        Винники
      </div>
      <div className="text-[#A81414] font-bold pt-2">
        ОРАТОРІЯ СВЯТОГО ІВАНА БОСКО – КИЇВ
      </div>
      <div className="text-[#A81414]">
        Відповідальний:
      </div>
      <div className="text-[#A81414]">
        Отець Андрій Платош, СДБ
      </div>
      <div className="text-[#A81414]">
        Вул. Вакуленчука 34
      </div>
      <div className="text-[#A81414]">
        Київ
      </div>
    </>,
    <div>
      <ul className="flex flex-col text-justify hyphens-auto ">
        <li>
          Парафія є обличчям Церкви. Це точка відліку, яка робить церкву видимою та соціально-включеною в щоденне життя. Парафія є спільнотою, яка супроводжує вибір покликання вірних, особливо молоді. Апостольська ревність отця Боско для найбіднішої молоді Турина спонукала його створити парафію для молоді без парафії. Сам отець Боско свого часу прийняв сім парафій. У 1887 році він написав положення про правильне функціонування парафії.
        </li>
        <li className="py-5">
          Він торкнувся тих питань, які його найбільше хвилюють: першочергова увага до молоді, особливо найбіднішої, та ідентичність салезіянського пароха, який служить там у сопричасті з єпископом і єпархіальним духовенством.
          Для нас, салезіян, парафія є середовищем, в якому ми знаходимо широкі можливості та сприятливі умови для навчання молоді робітничого класу чи з бідного середовища.
        </li>
        <li>
        </li>
      </ul>
    </div>,
    <div>
      <ul className="flex flex-col gap-5 text-justify hyphens-auto ">
        <li>
Школа є незамінним інструментом освіти, місцем зустрічі культури та віри. Вона є вирішальним місцем у формуванні особистості, оскільки передає концепцію світу, людини та історії. Шкільне середовище набуло значного розвитку в громаді у відповідь на потреби самої молоді, суспільства та Церкви.                    

        </li>
        <li>
   Салезіяни святого Івана Боско опікуються НВК “Школа-гімназія Шептицьких”, через яку можуть виховувати та формувати школярів та прививати їм життєву цінність бути добрим християнином та чесним громадянином.
        </li>
      </ul>

      <div className="text-[#A81414]  pt-2">
        Директор школи
      </div>
      <div className="text-[#A81414]">
        Отець Тарас Байовський, СДБ
      </div>
      <div className="text-[#A81414]">
        Вул. Гната Хоткевича, 16
      </div>
      <div className="text-[#A81414]">
        Львів
      </div>
    </div>

    ,
    <div className="text-justify hyphens-auto">
      <ul className="flex flex-col gap-5 text-justify hyphens-auto ">
        <li>
          Спортивний клуб «Дон Боско» був заснований в 2006 році і є покликаний надати дітям можливість розвивати їх дух і тіло в позашкільний час. Футбольний Клуб «Покрова», який входить до структури СК «Дон Боско» налічує понад 250 дітей різних вікових груп.
        </li>
        <li className="text-center">
          <span className="text-2xl text-[#A81414]">Мріяти, вірити, досягти</span> – це слоган клубу.
        </li>
        <li>
          Основним завданням це виховувати дітей до віри у Ісуса Христа, через катехитичні зустрічі та молитву. Навчити дітей жити християнським життя через Святі Тайни, особливо Тайну Покаяння та Євхаристії. Запропонувати їм як зразок прикладних осіб, які вірно живуть згідно християнським цінностям. Трж ми притримуємось думки, що у здоровому тілі здоровий дух.
        </li>
        <li>
          Завданням клубу є допомогу кожному реалізувати життєву мрію, відкрити багатство особистості через футбол, супровід, підтримку, командний дух, через поразки та здобутки. Адже тренер стає наставником, другом та батьком. Футбольний Клуб «Покрова» – це є місце добрих стосунків з Богом, з ближнім а також можливість отримати добру професійну підготовку футболіста. Футбольний Клуб «Покрова», втілює засади справжнього, відданого ідеалу футболу.
        </li>
        <li>
          Клуб бере участь з 2006 року у ДЮФЛУ першої ліги та вищої ліги України. З 2022 року була створена команда U-19 для юнаків, яка допомагає продовжити ігрову практику та віднайти себе у футболі. Футбольна база “Покрови” знаходиться на вулиці Дорога Кривчицька, 19, (спортзал “Боско-арена)” з прилеглими приміщеннями, а також футбольне поле зі штучним покриттям.

        </li>
        <li>
          Вікові групи Футбольний Клуб «Покрова» починаючи від найстарших до наймолодших.

        </li>
        <div className="flex flex-col">
          <li>Президент клубу - отець Анатолій Гецянин, СДБ</li>
          <li>Спортивний директор Олег Бойчишин</li>
        </div>
        <li className="italic">Запис до клубу можна зробити за номером телфону, або у соціальних мережах:</li>
        <div className="flex flex-col">
          <li className="text-[#A81414]">База клубу:</li>
          <li className="text-[#A81414]">Вул. Дорога Кривчицька, 19</li>
          <li className="text-[#A81414]">Львів</li>
          <li className="text-[#A81414]">+380676964170</li>
          <li className="underline text-[#A81414]">
            <a href="https://www.facebook.com/p/FC-Pokrova-Lviv-100079752860064/">Facebook</a>
          </li>
        </div>
      </ul>
    </div>,
    <div className="text-justify hyphens-auto">
      Приватний Заклад “Молодіжний навчальний центр імені святого Івана Боско” (далі - Центр) є приватним професійно-технічним навчальним закладом II - рівня атестації і забезпечує реалізацію потреб громадян у професійно-технічній освіті, оволодінні робітничими професіями відповідно до їх інтересів, потреб, стану здоров'я і є єдиним в Україні приватним католицьким закладом. Заклад розпочав свою діяльність з 2003 року.
      <br /><br />Центр здійснює первинну професійну підготовку робітників, як правило, з числа випускників загальноосвітніх навчальних закладів на основі базової чи повної загальної середньої освіти.
      <br /><br />Формування учнівського контингенту проводиться згідно із «Правилами прийому до ПЗ «Молодіжний навчальний центр імені св. Івана Боско», виходячи з потреб регіону в робітничих кадрах. Підготовка кваліфікованих робітників за професією здійснюється на підставі робочих навчальних планів, які розроблені у відповідності до вимог, погоджені і затверджені в установленому порядку з врахуванням регіонального компоненту.
      <br /><br />Навчально-виховний процес забезпечують педагогічні працівники з відповідною базовою і фаховою освітою.
      <br /><br />Велика увага приділяється соціальному захисту дітей, позбавлених батьківського піклування, дітей-сиріт, напівсиріт та дітей із малозабезпечених сімей.
      <br /><br />Організація навчально-виховної діяльності Центру здійснюється за перспективним планом роботи на навчальний рік та іншими нормативно-правовими документами. Тому МНЦ покликаний надати не тільки освіту та професійні здібності цим дітям, орієнтуючи на майбутнє залучення у світ праці, але й зайнятись їх вихованням і формуванням зрілої особистості. Дбати про їх духовний розвиток, насамперед вести їх у воцерковлене життя.
      <br /><br />Професії, які є на базі Центру:
      <ul className="pl-6 list-disc">
        <li>автомеханік,</li>
        <li>ІТ-розробник,</li>
        <li>кухар-офіціант,</li>
        <li>столяр.</li>
      </ul>
    </div>,
    <div className="text-justify hyphens-auto">
      <div className="pt-5">
        Родинний Дім «Покрова» розпочав свою історію ще в 2007 році при церкви Покрову Пресвятої Богородиці. Перші приміщення були реконструйовані з допомогою добродіїв з Ліхтенштейну які знаходилися в самій вежі церкви. Все розпочалось з прийняття Романа, а також восьми інших дітей. З часом для родинного дому «Покрова» були виділені приміщення другого поверху будинку, де була можливість помістити близько сорок дітей. Тим часом на вул. Дорога Кривчицька 19, розпочалося будівництво нового помешкання для дітей і в 2014 році, розпочинаючи з червня, діти переїхали до свого нового і остаточного дому. Спільнота Молодіжного Центру призначила два поверхи будинку для діяльності родинного Дому, де діти проживають, виховуються та готуються до повнолітнього життя.
      </div>
      <div className="pt-5">
        По суті, наш Центр створений для забезпечення, утримання та виховання дітей-сиріт, дітей позбавлених батьківського піклування та дітей, які опинилися у важких життєвих обставинах, а також створення сприятливих умов, максимально наближених до домашніх, для організації життя, всестороннього та цілісного розвитку дітей. Виховання в них високих моральних якостей, взаємоповаги терпимості, любові до ближнього, на основі християнських норм моралі і поведінки.
      </div>
      <div className="pt-5">
        Оточення кожного вихованця наповнене турботою і увагою, відповідно до салезіянської превентивної педагогічної системи виховання. Крім того, важливим аспектом є допомога вихованцям для своєчасного одержання необхідної освіти, підготовки до самостійного життя, вибору професії і праці.
      </div>
      <div className="text-[#A81414] pt-2">Директор Михайло Чабан</div>
      <div className="text-[#A81414]">Вул. Дорога Кривчицька, 19</div>
      <div className="text-[#A81414]">Львів</div>
    </div>,
    'текст1',
    <div className="text-justify hyphens-auto">
      При Салезіянському Згромадженні функціонують кампус і колегіум. Кампус, що розташований в Салезіянському Домі “Покрова”, пропонує проживання, духовний супровід та християнські засади для студентів університетів. Для студентів пропонується затишний простір і навчальні пропозиції. Зазвичай вони пов’язані з салезіянською діяльністю, в якій є й інші пропозиції для розвитку: ораторія, молодіжний центр, парафія тощо. Таким чином студенти опиняються під захистом і сприянням салезіянської спільноти, відповідальної за діяльність.
      <br /><br />
      Колегіум для студентів Центру професійної освіти Боско, також створений для формації студентів, їхнього духовного, інтелектуального розвитку, спираючись на превентивну систему святого Івана Боско.

      <br /><br />
      Оперативне управління, як правило, довіряється мирянину або самому салезіянину в супроводі інших співпрацівників. Так як і салезіянська виховна діяльність, колегії та гуртожитки покликані сприяти спільнотам, у яких розробляється виховний проект з пропозицією досвіду виховного та душпастирського супроводу.
      <div className="text-[#A81414] pt-5">Адреса кампусу: Львів, вул. Личаківська, 175 </div>
      <div className="text-[#A81414]">Відповідальний: о. Роман Боднар</div>
      <div className="text-[#A81414]">+380 96 520 36 60</div>
      <div className="text-[#A81414] pt-5">Адреса колегіуму: Львів, вул. Дорога Кривчицька, 19</div>
      <div className="text-[#A81414]">Відповідальний: о. Петро Васьків </div>
      <div className="text-[#A81414]">+380 097 370 73 33</div>
    </div>,
    <div className="text-justify hyphens-auto">
      «Історична пам’ять» руху сягає 24 червня 1870 року, дня, коли група «перших студентів» з’явилася в ораторії Турину, щоб відвідати та привітати отця Боско з нагоди його іменин, які відзначався в цю дату. Перша «братерська агапе» відбулася 19 липня 1874 р. і започаткувала звичай щорічної конференції, яка й сьогодні відбувається в салезіянських домах.
      <br /><br />У 1884 році перша група з 300 «старих студентів» взяла на себе зобов’язання підтримувати отримане виховання, продовжувати працювати на користь нужденної молоді, плекати дружбу та солідарність серед членів. Перший статут було складено в Турині 8 грудня 1911 року з нагоди першого Міжнародного конгресу проведеним отцем Филипом Рінальді.
      <br /><br />Випусники отця Боско – це люди, які брали участь в ораторії, школі чи інших салезіянських діяльностях та отримали підготовку до життя на основі принципів превентивної системи отця Боско: розуму, релігії та діючої любові.
    </div>,

    <div className="text-justify hyphens-auto">
      Молодіжний Салезіянський Рух - це рух, який об’єднує всю молодь і молодіжні асоціації, що присутні в Салезіянських Домах і які визнають себе приналежними до салезіянської духовності, перебуваючи у салезіянському вихованні.
      <br /><br />Молодіжний Салезіянський Рух (МСР) офіційно розпочався у 1988 році, у сторіччя смерті святого Івана Боско, і складається з молодді, яка бере участь у пропозиціях та діяльності Салезіянських домів.
      <br /><br />Є два елементи ідентичності МСР: посилання на салезіянську молодіжну духовність (СМД) і зв’язок між групами, асоціаціями та молодіжними реаліями, які нею надихаються. Поряд із зустрічами та діяльністю кожної групи чи місцевої реальності, провінційні, національні, міжнародні та всесвітні зустрічі молоді, літургійні святкування та салезіянські свята, а також навчання аніматорів визнаються сильними моментами досвіду спільноти. На територіальному рівні Провінція координує присутність Салезіанської Родини на своїй території та забезпечує включення МСР у контекст салезіанського виховно-душпастирського проекту (ВДП).
      <br /><br />МСР супроводжує хлопців та дівчат, як на особистому рівні, так і в груповій та динаміці середовища. Все це для того, аби, як сказав отець Боско, вони могли бути «добрими християнами, чесними громадянами і в майбутньому гідними мешканцями Неба». Привілейованими сферами зростання для молодді МСР є апостольська, особиста та громадська відданість, соціально-політична та відданість справедливому, братерському та суспільству, яке підтримує. Місцевий рівень є фундаментальним і незамінним: це місце, де молода людина відчуває і переживає молодіжну Салезіянську Духовність у повсякденному житті з багатством груп, діяльності та інтересів іншої молоді. На регіональному, національному та міжнародному рівнях періодично проводяться широкі ініціативи, які дають молоді можливість подолати кордони їхньої місцевої реальності та дозволяють насолоджуватися радістю «відчувати себе багатьма» та поділяти однакові цінності СМД.
    </div>,
  ]
  return (
    <>
      <section className="pb-10">
        <div className="container">
          <Heading name="Новини" />
          <section className="md:pb-20">
            <div className="grid grid-cols-1 md:grid-rows-6 gap-4 md:grid-cols-3 md:max-h-[372px]">
              <a href="/zustrich-vertepiv-spilnot-molodizhnoho-saleziianskoho-rukhu" className="relative max-md:h-[200px] md:col-span-1 md:row-span-3">
                <div className="!rounded-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-10"></div>
                <p
                  className="!rounded-tl-lg !rounded-br-lg !border-0 !normal-case !bg-[#A81414] !text-md md:!text-[20px] !py-1 !absolute !top-[0px] !left-[0px] !text-white !z-100 !w-[100%] max-w-max !text-center !hover-underline-animation px-2"
                >
                  Новини провінції
                </p>
                <p
                  className="!rounded-b-lg !border-0 !normal-case !bg-[#f0eded] !text-base md:!text-lg !py-1 !absolute !bottom-[0px] !left-[0px] !text-black !z-100 !w-[100%] !text-start !hover-underline-animation px-2"
                >
                  “Зустріч вертепів спільнот Молодіжного Салезіянського Руху”
                </p>
                <img className="!rounded-xl object-cover w-full h-full object-top" src={news} alt="" />
                <img className="absolute bottom-0 right-0 !rounded-xl object-cover object-top w-[30px] h-[30px] " src={"images/link-to.png"} alt="" />
              </a>
              <a href="/rozzbroity-nashi-sertsia-zarady-myru" className="relative max-md:h-[200px] md:col-span-1 md:row-span-3">
                <div className="!rounded-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-10"></div>
                <p

                  className="!rounded-tl-lg !rounded-br-lg !border-0 !normal-case !bg-[#A81414] !text-md md:!text-[20px] !py-1 !absolute !top-[0px] !left-[0px] !text-white !z-100 !w-[100%] max-w-max !text-center !hover-underline-animation px-2"
                >
                  Новини Генерального Дому
                </p>
                <p
                  className="!rounded-b-lg !border-0 !normal-case !bg-[#f0eded] !text-base md:!text-lg !py-1 !absolute !bottom-[0px] !left-[0px] !text-black !z-100 !w-[100%] !text-start !hover-underline-animation px-2"
                >
                  “Роззброїти наші серця заради миру”
                </p>
                <img className="!rounded-xl object-cover w-full h-full object-top" src={ugkc} alt="" />
                <img className="absolute bottom-0 right-0 !rounded-xl object-cover object-top w-[30px] h-[30px] " src={"images/link-to.png"} alt="" />
              </a>
              <a
                href="/svyatij-ivan-bosko"
                className="group max-md:order-4 relative max-md:h-[70px] md:col-span-1 md:row-span-2"
              >
                <div className="!rounded-xl pt-1 absolute left-[50%] -translate-x-2/4 text-white z-0 bg-[#A81414] h-full w-full"></div>

                <p
                  className="!rounded-lg !border-0 !normal-case font-medium !inset-x-0 top-[50%] -translate-y-[50%] !text-md md:!text-[40px] !py-1 !absolute !left-[35px] !text-white !z-10 !w-[100%] max-w-max !text-center !hover-underline-animation px-2"
                >
                  Хто ми
                </p>

                <img
                  className="!absolute !rounded-xl w-[44px] h-[44px] md:top-[50%] md:-translate-y-[50%] md:right-[35px] bottom-0 right-0 z-10 pointer-events-auto"
                  src="images/link-to.png"
                  alt=""
                />
              </a>
              <a
                href="/piznaj-svoye-poklikannya"
                className="group max-md:order-4 relative max-md:h-[70px] md:col-span-1 md:row-span-2"
              >
                <div className="!rounded-xl pt-1 absolute left-[50%] -translate-x-2/4 text-white z-0 bg-[#A81414] h-full w-full"></div>

                <p
                  className="!rounded-lg !border-0 !normal-case font-medium !inset-x-0 top-[50%] -translate-y-[50%] !text-md md:!text-[40px] !py-1 !absolute !left-[35px] !text-white !z-10 !w-[100%] max-w-max !text-center !hover-underline-animation px-2"
                >
                  Покликання
                </p>
                <img
                  className="!absolute !rounded-xl w-[44px] h-[44px] md:top-[50%] md:-translate-y-[50%] md:right-[35px] bottom-0 right-0 z-10 pointer-events-auto"
                  src="images/link-to.png"
                  alt=""
                />
              </a>

               <a href="/gaslo-2026" className="relative max-md:h-[200px] md:col-span-1 md:row-span-3">
                <div className="!rounded-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-10"></div>
                {/* <p

                  className="!rounded-tl-lg !rounded-br-lg !border-0 !normal-case !bg-[#A81414] !text-md md:!text-[20px] !py-1 !absolute !top-[0px] !left-[0px] !text-white !z-100 !w-[100%] max-w-max !text-center !hover-underline-animation px-2"
                >
                  Новини Генерального Дому
                </p> */}
                {/* <p
                  className="!rounded-b-lg !border-0 !normal-case !bg-[#f0eded] !text-base md:!text-lg !py-1 !absolute !bottom-[0px] !left-[0px] !text-black !z-100 !w-[100%] !text-start !hover-underline-animation px-2"
                >
                  “Гасло 2026”
                </p> */}
                <img className="!rounded-xl object-cover w-full h-full object-[position:50%_-220px] md:object-[position:50%_-270px]" src={gaslo} alt="" />
                {/* <img className="absolute bottom-0 right-0 !rounded-xl object-cover object-top w-[30px] h-[30px] " src={"images/link-to.png"} alt="" /> */}
              </a>
              <a href="/poslannia-heneralnoho-nastoiatelia-saleziian-na-sichen-2026" className="relative max-md:h-[200px] md:col-span-1 md:row-span-3">
                <div className="!rounded-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-10"></div>
                <p
                  className="!rounded-tl-lg !rounded-br-lg !border-0 !normal-case !bg-[#A81414] !text-md md:!text-[20px] !py-1 !absolute !top-[0px] !left-[0px] !text-white !z-100 !w-[100%] max-w-max !text-center !hover-underline-animation px-2"
                >
                  Новини Генерального Дому
                </p>
                {/* <p
                  className="!rounded-b-lg !border-0 !normal-case !bg-[#f0eded] !text-base md:!text-lg !py-1 !absolute !bottom-[0px] !left-[0px] !text-black !z-100 !w-[100%] !text-start !hover-underline-animation px-2"
                >
                  “Кошик Мами Маргарити”
                </p> */}
                <img className="!rounded-xl object-cover w-full h-full" src={general} alt="" />
                {/* <img className="absolute bottom-0 right-0 !rounded-xl object-cover object-top w-[30px] h-[30px] " src={"images/link-to.png"} alt="" /> */}


              </a>
              <a
              target="_blank"
                href="https://ugcc.ua/"
                className="group max-md:order-4 relative max-md:h-[70px] md:col-span-1 md:row-span-2"
              >
                <div className="!rounded-xl pt-1 absolute left-[50%] -translate-x-2/4 text-white z-0 bg-[#A81414] h-full w-full"></div>
                <p
                  className="!rounded-lg !border-0 !normal-case font-medium !inset-x-0 top-[50%] -translate-y-[50%] !text-md md:!text-[40px] !py-1 !absolute !left-[35px] !text-white !z-10 !w-[100%] max-w-max !text-center !hover-underline-animation px-2"
                >
                  УГКЦ
                </p>
                <img
                  className="!absolute !rounded-xl w-[44px] h-[44px] md:top-[50%] md:-translate-y-[50%] md:right-[35px] bottom-0 right-0 z-10 pointer-events-auto"
                  src="images/link-to.png"
                  alt=""
                />
              </a>
            </div>
          </section>
        </div>
      </section>
      <section className="pb-10 bg-orange">
        <div className="container">
          <Heading name="Душпастирство молоді" />
          <h3 className="flex pb-10 text-base text-justify hyphens-auto md:text-xl font-robotoLight">
            Душпастирство у Салезіянському розумінні – це духовний супровід всіх видів діяльності Провінції, з особливим акцентом на дітей та молодь найбільш потребуючу та відкинуту суспільством. В кожному часі історії Церкви підходи душпастирювання різнилися, але ціль та мета залишаються незмінними, оскільки головним завданням душпастирювання є спасіння власної душі і довіреної йому пастви. Автентичне душпастирство відбувається через священнослужіння – звершення Святих Таїнств, обрядів й інших молитовних дійств. Це та основа, на якій побудоване духовне життя віруючої людини. Також проповідь Євангелія, ведення активної внутрішньої та зовнішньої місії. І, напевно, один із найфундаментальніших елементів душпастирювання є духовний супровід та наставництво, яке можемо назвати пасторальним мистецтвом душпастирства.
          </h3>
          <div className="grid grid-cols-1 gap-4 text-center text-black md:grid-cols-2 lg:grid-cols-3">
            <div className="py-4 m-1 bg-white !rounded-xl">
              <div
                className="!border-0 !px-4 !py-0 !text-black !uppercase !rounded-lg !bg-white !hover:underline !text-2xl !normal-case !hover-underline-animation"

              >
                <a
                  href="/oratoria"
                >
                  Ораторія
                </a>
              </div>
              {/* <CustomizedDialogs
                buttonClassName={"!border-0 !px-4 !py-0 !text-black !uppercase !rounded-lg !bg-white !hover:underline !text-2xl !normal-case !hover-underline-animation"}
                buttonText="Ораторія"
                modalTitle={"Ораторія"}
                modalText={popups[0]}
              /> */}
            </div>
            <div className="py-4 m-1 bg-white !rounded-xl">
              <div
                className="!border-0 !px-4 !py-0 !text-black !uppercase !rounded-lg !bg-white !hover:underline !text-2xl !normal-case !hover-underline-animation"

              >
                <a
                  href="/parafia"
                >
                  Парафія
                </a>
              </div>
            </div>
            <div className="py-4 m-1 bg-white !rounded-xl">
              <div
                className="!border-0 !px-4 !py-0 !text-black !uppercase !rounded-lg !bg-white !hover:underline !text-2xl !normal-case !hover-underline-animation"

              >
                <a
                  href="/shkola"
                >
                  Школа
                </a>
              </div>
            </div>
            <div className="py-4 m-1 bg-white !rounded-xl">
              <div
                className="!border-0 !px-4 !py-0 !text-black !uppercase !rounded-lg !bg-white !hover:underline !text-2xl !normal-case !hover-underline-animation"

              >
                <a
                  href="/sportpage"
                >
                  Спорт
                </a>
              </div>
            </div>
            <div className="py-4 m-1 bg-white !rounded-xl">
              <div
                className="!border-0 !px-4 !py-0 !text-black !uppercase !rounded-lg !bg-white !hover:underline !text-2xl !normal-case !hover-underline-animation"

              >
                <a
                  href="/osvita"
                >
                  Професійна освіта
                </a>
              </div>
            </div>
            <div className="py-4 m-1 bg-white !rounded-xl">
              <div
                className="!border-0 !px-4 !py-0 !text-black !uppercase !rounded-lg !bg-white !hover:underline !text-2xl !normal-case !hover-underline-animation"

              >
                <a
                  href="/rodynnyi"
                >
                  Родинний дім "Покрова"
                </a>
              </div>
            </div>
            <div className="py-4 m-1 bg-white !rounded-xl">
              <div
                className="!border-0 !px-4 !py-0 !text-black !uppercase !rounded-lg !bg-white !hover:underline !text-2xl !normal-case !hover-underline-animation"

              >
                <a
                  href="/studenty"
                >
                  Студенти
                </a>
              </div>
            </div>
            <div className="py-4 m-1 bg-white !rounded-xl">
              <div
                className="!border-0 !px-4 !py-0 !text-black !uppercase !rounded-lg !bg-white !hover:underline !text-2xl !normal-case !hover-underline-animation"

              >
                <a
                  href="/vypusknyky"
                >
                  Випускники
                </a>
              </div>
            </div>
            <div className="py-4 m-1 bg-white !rounded-xl">
              <div
                className="!border-0 !px-4 !py-0 !text-black !uppercase !rounded-lg !bg-white !hover:underline !text-2xl !normal-case !hover-underline-animation"

              >
                <a
                  href="/msr"
                >
                  Молодіжний Салезіянський Рух
                </a>
              </div>
            </div>
            {/* <div className="py-4 m-1 bg-white !rounded-xl">
              <CustomizedDialogs
                buttonClassName={"!border-0 !px-4 !py-0 !text-black !uppercase !rounded-lg !bg-white !hover:underline !text-2xl !normal-case !hover-underline-animation"}
                buttonText="Парафія"
                modalTitle={"Парафія"}
                modalText={popups[1]}
              />
            </div>
            <div className="py-4 m-1 bg-white !rounded-xl">
              <CustomizedDialogs
                buttonClassName={"!border-0 !px-4 !py-0 !text-black !uppercase !rounded-lg !bg-white !hover:underline !text-2xl !normal-case !hover-underline-animation"}
                buttonText="Школа"
                modalTitle={"Школа"}
                modalText={popups[2]}
              />
            </div>
            <div className="py-4 m-1 bg-white !rounded-xl">
              <CustomizedDialogs
                buttonClassName={"!border-0 !px-4 !py-0 !text-black !uppercase !rounded-lg !bg-white !hover:underline !text-2xl !normal-case !hover-underline-animation"}
                buttonText="Спорт"
                modalTitle={"Спорт"}
                modalText={popups[3]}
              />
            </div>
            <div className="py-4 m-1 bg-white !rounded-xl">
              <CustomizedDialogs
                buttonClassName={"!border-0 !px-4 !py-0 !text-black !uppercase !rounded-lg !bg-white !hover:underline !text-2xl !normal-case !hover-underline-animation"}
                buttonText="Професійна освіта"
                modalTitle={"Центр професійного освіти Боско"}
                modalText={popups[4]}
              />
            </div>
            <div className="py-4 m-1 bg-white !rounded-xl">
              <CustomizedDialogs
                buttonClassName={"!border-0 !px-4 !py-0 !text-black !uppercase !rounded-lg !bg-white !hover:underline !text-2xl !normal-case !hover-underline-animation"}
                buttonText={'Родинний дім "Покрова"'}
                modalTitle={'Родинний дім "Покрова"'}
                modalText={popups[5]}
              />
            </div> */}
            {/* <div className="p-4 m-1 bg-red">
              <CustomizedDialogs
                buttonClassName={"!border-0 !px-4 !py-1 !text-white !uppercase !rounded-lg !bg-red !hover:underline !text-2xl !normal-case !hover-underline-animation"}
                buttonText="Колегія святого Івана Боско"
                modalTitle={"Колегія святого Івана Боско"}
                modalText={popups[7]}
              />
            </div> */}
            {/* <div className="py-4 m-1 bg-white !rounded-xl">
              <CustomizedDialogs
                buttonClassName={"!border-0 !px-4 !py-0 !text-black !uppercase !rounded-lg !bg-white !hover:underline !text-2xl !normal-case !hover-underline-animation"}
                buttonText="Студенти"
                modalTitle={"Студенти – (Кампус )"}
                modalText={popups[7]}
              />
            </div>
            <div className="py-4 m-1 bg-white !rounded-xl">
              <CustomizedDialogs
                buttonClassName={"!border-0 !px-4 !py-0 !text-black !uppercase !rounded-lg !bg-white !hover:underline !text-2xl !normal-case !hover-underline-animation"}
                buttonText="Випускники"
                modalTitle={"Випускники"}
                modalText={popups[8]}
              />
            </div> */}
            {/* <div className="p-4 m-1 bg-red">
              <CustomizedDialogs
                buttonClassName={"!border-0 !px-4 !py-1 !text-white !uppercase !rounded-lg !bg-red !hover:underline !text-2xl !normal-case !hover-underline-animation"}
                buttonText="Молодь для молоді"
                modalTitle={"Молодь для молоді"}
                modalText={popups[10]}
              />
            </div> */}
            {/* <div className="py-4 m-1 bg-white !rounded-xl">
              <CustomizedDialogs
                buttonClassName={"!border-0 !px-4 !py-0 !text-black !uppercase !rounded-lg !bg-white !hover:underline !text-2xl !normal-case !hover-underline-animation"}
                buttonText="Молодіжний Салезіянський Рух"
                modalTitle={"Молодіжний Салезіянський Рух"}
                modalText={popups[9]}
              />
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default NewsSDB;
